export default __webpack_public_path__ + "static/media/modal_2_pet_es.e9c007c5.svg";